"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useIntersectionObserver;

var _react = _interopRequireDefault(require("react"));

/* global IntersectionObserver */
function useIntersectionObserver(_ref) {
  var root = _ref.root,
      target = _ref.target,
      onIntersect = _ref.onIntersect,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 1.0 : _ref$threshold,
      _ref$rootMargin = _ref.rootMargin,
      rootMargin = _ref$rootMargin === void 0 ? '0px' : _ref$rootMargin;

  _react["default"].useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      return entries.forEach(function (entry) {
        return entry.isIntersecting && onIntersect();
      });
    }, {
      root: root && root.current,
      rootMargin: rootMargin,
      threshold: threshold
    });
    var el = target && target.current;

    if (!el) {
      return;
    }

    observer.observe(el);
    return function () {
      observer.unobserve(el);
    };
  }, [target.current]);
}